import type { CallbackAction, LinkAction } from '@shopify/polaris'
import { createContext, useContext, useState } from 'react'

type LayoutContextType = {
  title?: string
  setTitle: (title?: string) => void

  subtitle?: string
  setSubtitle: (subtitle?: string) => void

  backAction: LinkAction | CallbackAction | undefined
  setBackAction: (backAction: LinkAction | CallbackAction | undefined) => void

  primaryAction: React.ReactNode | undefined
  setPrimaryAction: (primaryAction: React.ReactNode | undefined) => void

  fullWidth: boolean
  setFullWidth: (fullWidth: boolean) => void
}

export const LayoutContext = createContext<LayoutContextType | null>(null)

export const LayoutProvider = ({ children }: { children: React.ReactNode }) => {
  const [title, setTitle] = useState<string>()
  const [subtitle, setSubtitle] = useState<string>()
  const [backAction, setBackAction] = useState<LinkAction | CallbackAction>()
  const [primaryAction, setPrimaryAction] = useState<React.ReactNode>()
  const [fullWidth, setFullWidth] = useState<boolean>(true)

  return (
    <LayoutContext.Provider
      value={{
        title,
        subtitle,
        backAction,
        primaryAction,
        fullWidth,
        setTitle,
        setSubtitle,
        setBackAction,
        setPrimaryAction,
        setFullWidth
      }}
    >
      {children}
    </LayoutContext.Provider>
  )
}

export const useLayout = () => {
  const context = useContext(LayoutContext)

  if (!context) {
    throw new Error('useLayout must be used within a LayoutProvider')
  }

  return context
}
